module.exports = __webpack_public_path__ + "img/13.075397b3.png";